import algoliasearch from 'algoliasearch/lite'

import {
  DEFAULT_PARAMS,
  HITS_PER_PAGE_SEARCH_BOX,
  ANALYTICS_TAG_SUGGESTIONS,
  SEARCHABLE_FILTERS
} from 'shared/consts/algolia'

import assert from 'shared/utils/assert'
import { getDevicePlatform } from 'shared/utils/algolia/analyticsTags'

import getValidatorInstance from 'shared/services/api/helpers/getValidatorInstance'

import BackendAPIService from './BackendAPIService'

class ClientAPIService extends BackendAPIService {
  constructor(props) {
    super(props)

    const { searchConfig } = props

    assert(searchConfig, 'ClientAPIService: no "searchConfig" option provided')

    this.searchConfig = searchConfig
  }

  async searchAlgolia(query, { userToken, deviceClass = null }) {
    assert(query, 'ClientAPIService.searchAlgolia: please provide a "query"')
    this.logger.debug(
      `Fetching Search-Autosuggestions (Algolia) for "${query}"`,
      'dataFetchingAll'
    )

    const {
      algolia: { appId, apiKey, indexName }
    } = this.searchConfig

    const params = {
      ...DEFAULT_PARAMS,
      query,
      hitsPerPage: HITS_PER_PAGE_SEARCH_BOX,
      clickAnalytics: true,
      getRankingInfo: true,
      analyticsTags: [ANALYTICS_TAG_SUGGESTIONS, getDevicePlatform(deviceClass)]
    }

    const { valid } = getValidatorInstance(this.tenant).validate(query)
    if (valid) {
      params.filters = SEARCHABLE_FILTERS
    }

    const searchClientConfig = {}
    if (userToken) {
      params.userToken = userToken
      params.analytics = true
      searchClientConfig.headers = {}
      searchClientConfig.headers['X-Algolia-UserToken'] = userToken
    }

    const searchClient = algoliasearch(appId, apiKey, searchClientConfig)
    const index = searchClient.initIndex(indexName)

    const response = await index.search(query, params)

    this.logger.debug(
      `Search-Autosuggestions (Algolia) for "${query}" fetched!`,
      'dataFetchingAll'
    )

    return response
  }

  getLegalTextPath() {
    return `/cacheable/${this.language}/content/${this.apiVersion}/${this.tenantPath}/snippetsFooter`
  }

  async fetchLegalText() {
    this.logger.debug('Fetching LegalText', 'dataFetchingAll')
    const params = {
      contentsFilter: 'headline:legalText',
      fields: 'id title contents { headline content }'
    }
    const { status, data } = await this.get(this.getLegalTextPath(), { params })
    this.logger.debug('LegalText fetched!', 'dataFetchingAll')

    return {
      status,
      data: data.contents[0].content
    }
  }

  getOffCanvasCategoriesPath(id) {
    return `cacheable/${this.language}/categories/${this.apiVersion}/${this.tenantPath}/${id}`
  }

  async fetchOffCanvasCategories(id) {
    this.logger.debug('Fetching offcanvas categories', 'dataFetchingAll')

    const { data } = await this.get(this.getOffCanvasCategoriesPath(id))

    return data
  }
}

export default ClientAPIService
